import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetCamera: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 7a1 1 0 011-1h2.17a1 1 0 00.95-.68l.43-1.3A1 1 0 018.5 3h7a1 1 0 01.95.68l.43 1.3a1 1 0 00.95.68H20a1 1 0 011 1v11a1 1 0 01-1 1H4a1 1 0 01-1-1V7zm9 9a4 4 0 100-8 4 4 0 000 8z" />
      </svg>
    </div>
  );
};

export default WidgetCamera;
